export const environment = {
  /** Selects which environment-specific config block to use from msconfig.json. */
  env: 'prod' as 'prod' | 'dev',
};
